import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#1C1C1C] text-white flex items-center justify-center px-6 font-body" data-testid="admin-login">
      <div className="max-w-md w-full">
        <div className="text-center mb-10">
          <div className="w-14 h-14 bg-[#C1121F] flex items-center justify-center mx-auto mb-5">
            <span className="text-white font-heading font-bold text-2xl">D</span>
          </div>
          <div className="overline mb-3">Admin Panel</div>
          <h1 className="font-heading font-bold text-3xl">Sign in to manage your site</h1>
          <p className="mt-3 text-white/60 text-sm">Use your authorized Google account.</p>
        </div>

        {params.get("denied") && (
          <div className="bg-[#C1121F]/10 border border-[#C1121F]/40 text-[#C1121F] px-4 py-3 mb-6 text-sm">
            This Google account is not authorized for admin access. Contact your administrator to add your email to the allowlist.
          </div>
        )}
        {params.get("error") && (
          <div className="bg-[#C1121F]/10 border border-[#C1121F]/40 text-[#C1121F] px-4 py-3 mb-6 text-sm">
            Sign-in failed. Please try again.
          </div>
        )}

        <button
          onClick={handleLogin}
          className="w-full bg-white text-[#1C1C1C] hover:bg-white/90 transition-colors rounded-sm px-6 py-3 font-heading font-semibold flex items-center justify-center gap-3"
          data-testid="google-signin-btn"
        >
          <svg width="18" height="18" viewBox="0 0 18 18">
            <path d="M16.5 9.2c0-.6-.1-1.1-.2-1.7H9v3.2h4.2c-.2 1-.7 1.8-1.6 2.4v2h2.6c1.5-1.4 2.3-3.4 2.3-5.9z" fill="#4285F4" />
            <path d="M9 17c2.2 0 4-.7 5.3-2l-2.6-2c-.7.5-1.7.8-2.7.8-2.1 0-3.8-1.4-4.5-3.3H1.8v2.1C3.1 15.4 5.8 17 9 17z" fill="#34A853" />
            <path d="M4.5 10.5c-.2-.5-.3-1-.3-1.5s.1-1 .3-1.5V5.4H1.8C1.3 6.5 1 7.7 1 9s.3 2.5.8 3.6l2.7-2.1z" fill="#FBBC05" />
            <path d="M9 4.6c1.2 0 2.3.4 3.1 1.2l2.3-2.3C13 2.2 11.2 1.5 9 1.5 5.8 1.5 3.1 3.1 1.8 5.4l2.7 2.1C5.2 5.6 6.9 4.6 9 4.6z" fill="#EA4335" />
          </svg>
          Continue with Google
        </button>

        <p className="mt-8 text-center text-xs text-white/40">
          The first Google user to sign in is automatically promoted to admin. After that, only allowlisted emails (managed in Settings) can access the panel.
        </p>
      </div>
    </div>
  );
}
